import { Link } from 'react-router-dom'
import styles from './Home.module.css'
import { BsFillCaretRightFill } from 'react-icons/bs'
export default function Home() {
  return (
    <>
      <div className={styles.banner}>
        <div className={styles.conteiner}>
          <h1>
            <span>elas</span> perguntam, <span>eles</span> respondem <br />
            e vice-versa!
          </h1>
          <p>Como chegar na garota que você gosta?</p>
          <p>Por que ele prometeu ligar e não ligou?</p>
          <p><strong>Descubra como o sexo oposto pensa!</strong></p>
          <Link to='/login'><button >Participe agora <BsFillCaretRightFill /></button></Link>
        </div>
      </div>
      <div className={styles.sub_content}>
        <h1>
          Você vai amar o <span>ela</span><span>ele</span>
        </h1>
        <div className={styles.cards}>
          <div className={styles.card}>
            <h2>Pergunte</h2>
            <p>e receba respostas sinceras diretamente do sexo oposto </p>
          </div>
          <div className={styles.card}>
            <h2>Responda</h2>
            <p>compartilhe suas experiências e conheça pessoas interessantes</p>
          </div>
          <div className={styles.card}>
            <h2>É anônimo</h2>
            <p>sinta-se à vontade para perguntar coisas extremamente embaraçosas na vida real</p>
          </div>
        </div>
      </div>
    </>
  )
}